import { render, staticRenderFns } from "./SystockLayout.vue?vue&type=template&id=5ea83326"
import script from "./SystockLayout.vue?vue&type=script&lang=js"
export * from "./SystockLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports